import { CalendarViewUI } from './calendar-view-ui-logic.js';
import { CalendarSetupWizard } from './setup-wizard/calendar-setup-wizard.js';

export function pcEffects(): void {
  customElements.define('dv-calendar-view-ui', CalendarViewUI);
  customElements.define('dv-calendar-setup-wizard', CalendarSetupWizard);
}
